import React from 'react';
import { Helmet } from 'react-helmet';
import PageWrapper from 'components/pageWrapper';
import Content from './content';
import classes from './styles.module.scss';

const TokenCreator = () => {
  return (
    <>
      <Helmet>
        <title>Token Creator</title>
      </Helmet>
      <PageWrapper heading="Token Creator">
        <div className={classes.wrapper}>
          <Content />
        </div>
      </PageWrapper>
    </>
  );
};

export default TokenCreator;
